import { AxiosError } from 'axios';
import { NetworkErrors } from './axios-types';
import { isAxiosError, isNetworkError } from 'infrastructure/axios-helper';

export function errorAxiosInterceptor(e: any) {
  if (e instanceof AxiosError) {
    const status = e?.response?.status;
    if (status === 503) {
      throw new Error(NetworkErrors.Maintenance);
    }

    if (isNetworkError(e)) {
      const isOffline = isAxiosError(e) && e.message.includes('timeout of 15000ms exceeded');

      if (isOffline) {
        throw new Error(NetworkErrors.NoInternet);
      }
    }
  }

  throw e;
}
